import React, { useEffect } from 'react';
import './hero.css';

const Hero: React.FC = () => {
	return (
		<div className="hero-wrapper">
			<video
				className="hero-video"
				autoPlay
				loop
				muted
				playsInline
			>
				<source src="/assets/static/hiker.mp4" type="video/mp4" />
				Your Browser does not support the video tag
			</video>
			<div className="hero-overlay"></div>
			<div className="hero-content">
				<h1>At Hatch Data and Mental Health, We Are Advancing Detection and Treatment in Mental Health Using Open Source Technology</h1>
				<p>Providing Therapy and conducting research using leading-edge machine learning, data analytics, and research to push boundaries in care and diagnostics</p>
			</div>
		</div>
	)
}

export default Hero;
